"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _constants = require("./constants");

var _core = require("@emotion/core");

var AnimatedWrapper = function AnimatedWrapper(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      isAboveTrigger = _ref.isAboveTrigger;

  var _useState = (0, _react.useState)(isOpen),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isVisible = _useState2[0],
      setVisible = _useState2[1];

  var slideStartPosition = isAboveTrigger ? _constants.ANIMATION_SLIDE_AMOUNT : 0 - _constants.ANIMATION_SLIDE_AMOUNT;
  var closedStyles = {
    opacity: 0,
    transform: "translateY(".concat(slideStartPosition, "px)")
  };
  var openStyles = {
    opacity: 1,
    transform: "translateY(0)"
  };
  var initialStyles = isOpen ? openStyles : closedStyles;

  var _useSpring = (0, _reactSpring.useSpring)(function () {
    return (0, _objectSpread2.default)({
      config: {
        duration: _constants.ANIMATION_DURATION
      }
    }, initialStyles);
  }),
      _useSpring2 = (0, _slicedToArray2.default)(_useSpring, 2),
      springProps = _useSpring2[0],
      setSpringProps = _useSpring2[1];

  (0, _react.useEffect)(function () {
    // Make content visible before starting the animation
    if (isOpen) {
      setVisible(true);
      setSpringProps((0, _objectSpread2.default)({}, openStyles, {
        onRest: function onRest() {} // Do nothing after the animation ends

      }));
    } else {
      setSpringProps((0, _objectSpread2.default)({}, closedStyles, {
        onRest: function onRest() {
          // Make the content invisible after the animation ends
          setVisible(false);
        }
      }));
    }
  }, [isOpen, openStyles, closedStyles, setVisible]);
  return (0, _core.jsx)(_reactSpring.animated.div, {
    style: springProps
  }, isVisible ? children : null);
};

AnimatedWrapper.displayName = 'AnimatedWrapper';
var _default = AnimatedWrapper;
exports.default = _default;